import {Injectable} from "@angular/core";
import {cookiesService} from './cookies.service';
import {BehaviorSubject} from 'rxjs';


@Injectable({providedIn: "root"})

export class SettingsService {
  constructor(private cookies: cookiesService) {
  }

  public showHintAfterWrongAnswer = true;
  public showHintAfterCorrectAnswer = true;
  public autoNextQuestionAfterWrongAnswer = false;
  public autoNextQuestionAfterCorrectAnswer = false;

  public showResults_os = new BehaviorSubject<any>({});
  showResults_os$ = this.showResults_os.asObservable();

  public showResultsOnlyAfterCompletion = false;


  public open_settings = new BehaviorSubject<boolean>(false);

  open_settings$ = this.open_settings.asObservable();

  set_open_settings(value: boolean) {
    this.open_settings.next(value);
  }

  set_showHintAfterWrongAnswer() {
    if (!this.showResultsOnlyAfterCompletion) {

      this.showHintAfterWrongAnswer = !this.showHintAfterWrongAnswer;
      let d = new Date;
      let days = 365
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
      this.cookies.setCookie('showHintAfterWrongAnswer', this.showHintAfterWrongAnswer ? '1' : '0', {
        path: "/",
        expires: d.toString()
      })

    }
  }

  set_showHintAfterCorrectAnswer() {
    if (!this.showResultsOnlyAfterCompletion) {
      this.showHintAfterCorrectAnswer = !this.showHintAfterCorrectAnswer;
      let d = new Date;
      let days = 365
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
      this.cookies.setCookie('showHintAfterCorrectAnswer', this.showHintAfterCorrectAnswer ? '1' : '0', {
        path: "/",
        expires: d.toString()
      })
    }
  }

  set_autoNextQuestionAfterCorrectAnswer() {
    if (!this.showResultsOnlyAfterCompletion) {
      this.autoNextQuestionAfterCorrectAnswer = !this.autoNextQuestionAfterCorrectAnswer;
      let d = new Date;
      let days = 365
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
      this.cookies.setCookie('autoNextQuestionAfterCorrectAnswer', this.autoNextQuestionAfterCorrectAnswer ? '1' : '0', {
        path: "/",
        expires: d.toString()
      })
    }
  }

  set_autoNextQuestionAfterWrongAnswer() {
    if (!this.showResultsOnlyAfterCompletion) {
      this.autoNextQuestionAfterWrongAnswer = !this.autoNextQuestionAfterWrongAnswer;
      let d = new Date;
      let days = 365
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
      this.cookies.setCookie('autoNextQuestionAfterWrongAnswer', this.autoNextQuestionAfterWrongAnswer ? '1' : '0', {
        path: "/",
        expires: d.toString()
      })
    }
  }

  set_showResultsOnlyAfterCompletion() {
    this.showResultsOnlyAfterCompletion = !this.showResultsOnlyAfterCompletion;
    let d = new Date;
    let days = 365
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    this.cookies.setCookie('showResultsOnlyAfterCompletion', this.showResultsOnlyAfterCompletion ? '1' : '0', {
      path: "/",
      expires: d.toString()
    })
    this.showResults_os.next({});
  }
}
